import {FC, useEffect, useState} from 'react'
import {Button, Col, Form, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import Select from 'react-select'
import {getPlantV2, getProductName, getProductType, getSloc} from 'src/api/modules/getdatalist'

type Prop = {
    onFilter: (p1: any) => void
    loading: boolean
}

export const Filter: FC<Prop> = ({
    onFilter,
    loading
}) => {
  const {t} = useTranslation()

  const [fullProductType, setFullProductType] = useState<any[]>([])
  const [fullProductName, setFullProductName] = useState<any[]>([])
  const [fullPlant, setFullPlant] = useState<any[]>([])
  const [fullSloc, setFullSloc] = useState<any[]>([])

  const [productType, setProductType] = useState('')
  const [productName, setProductName] = useState('')
  const [productUnit, setProductUnit] = useState('')
  const [plant, setPlant] = useState('')
  const [sloc, setSloc] = useState<any>('')

  const fetchProductType = async () => {
    try {
      setFullProductType([])
      await getProductType('').then((res: any) => {
        let data = [
          {
            value: '',
            label: t('pilih')
          }
        ]
        res.data.data.forEach((item: any) => {
          data.push({
            value: item.material_group,
            label: item.material_group + ' - ' + item.material_group_desc,
          })
        })
        setFullProductType(data)
      })
    } catch {}
  }

  const fetchProductName = async () => {
    setFullProductName([])
    setFullPlant([])

    await getProductName(plant, '', productType, '', '', {}).then((res: any) => {
      let data = [
        {
          value: '',
          label: t('pilih')
        }
      ]
      res.data.data.forEach((item: any) => {
        data.push({
          value: [
            parseInt(item.material_number)+'',
            item.unit,
          ].join("~#~"),
          label: parseInt(item.material_number) + ' - ' + item.material_description,
        })
      })

      setFullProductName(data)
    })
  }
  const fetchPlant = async () => {
    setFullPlant([])
    setFullSloc([])

    await getPlantV2('', productName).then((res) => {
      let data = [
        {
          value: '',
          label: t('pilih')
        }
      ]
      res.data.data.forEach((item: any) => {
        data.push({
          value: item.plant,
          label: item.plant + '-' + item.plant_name,
        })
      })

      setFullPlant(data)
    })
  }
  const fetchSloc = async () => {
    setFullSloc([])
    
    await getSloc(plant, '', productName, '', '').then((res: any) => {
      let data = [
        {
          value: '',
          label: t('pilih')
        }
      ]

      res.data.data.forEach((item: any) => {
        data.push({
          value: item.sloc,
          label: item.sloc + '-' + item.sloc_description,
        })
      })
      setFullSloc(data)
    })
  }

  useEffect(() => {
    fetchProductType()
  }, [])
  useEffect(() => {
    setProductName('')
    fetchProductName()
  }, [productType])
  useEffect(() => {
    setPlant('')
    fetchPlant()
  }, [productName])
  useEffect(() => {
    setSloc('')
    fetchSloc()
  }, [plant])

  const filter = () => {
    onFilter({
        product_type: productType,
        unit: productUnit,
        material_number: productName,
        plant,
        sloc,
    })
  }

  return (
    <>
      <div>
        <Row>
          <Col md={6}>
            <Row className='mb-4'>
              <Col md={4} className='mt-2'>
                <Form.Label className='mt-2'>{t('sub-order-jenis')}</Form.Label>
              </Col>
              <Col sm={8}>
                <Select
                  isDisabled={loading}
                  placeholder={t('pilih')}
                  value={
                    fullProductType[
                      fullProductType.findIndex((item: any) => item.value == productType)
                    ]
                  }
                  onChange={(e: any) => {
                    setProductType(e.value)
                  }}
                  options={fullProductType}
                  menuPortalTarget={document.body} 
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 3 }) }}
                />
              </Col>
            </Row>
          </Col>

          <Col md={6}>
            <Row className='mb-4'>
              <Col md={4} className='mt-2'>
                <Form.Label className='mt-2'>{t('sub-order-produk')}</Form.Label>
              </Col>
              <Col sm={8}>
                <Select
                    isDisabled={loading}
                  id='produk'
                  placeholder={t('pilih')}
                  value={
                    fullProductName.find((item: any) => item.value == [
                        productName,
                        productUnit
                    ].join("~#~"))
                  }
                  onChange={(e: any) => {
                    let split = e.value?.split("~#~")
                    setProductName(split[0])
                    setProductUnit(split[1])
                  }}
                  options={fullProductName}
                  menuPortalTarget={document.body} 
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 3 }) }}
                />
              </Col>
            </Row>
          </Col>

          <Col md={6}>
            <Row className='mb-4'>
              <Col md={4} className='mt-2'>
                <Form.Label className='mt-2'>{t('sub-order-gudang')}</Form.Label>
              </Col>
              <Col sm={8}>
                <Select
                    isDisabled={loading}
                  id='gudang'
                  placeholder={t('pilih')}
                  value={fullPlant[fullPlant.findIndex((item: any) => item.value == plant)]}
                  onChange={(e: any) => setPlant(e?.value)}
                  options={fullPlant}
                  menuPortalTarget={document.body} 
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 3 }) }}
                />
              </Col>
            </Row>
          </Col>

          <Col md={6}>
            <Row>
              <Col md={4} className='mt-2'>
                <Form.Label className='mt-2'>{t('storage location')}</Form.Label>
              </Col>
              <Col md={8}>
                <Select
                    isDisabled={loading}
                  placeholder={t('pilih')}
                  value={
                    sloc == null || sloc == 'null'
                      ? ''
                      : fullSloc[fullSloc.findIndex((item: any) => item.value == sloc)]
                  }
                  onChange={(e: any) => setSloc(e?.value)}
                  options={fullSloc}
                  menuPortalTarget={document.body} 
                  styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 3 }) }}
                />
              </Col>
            </Row>
          </Col>
        </Row>

        <div className='d-flex justify-content-end mt-5'>
          <Button disabled={loading} variant='primary' onClick={filter}>
            {loading ? '...' : t('cari')}
          </Button>
        </div>
      </div>
    </>
  )
}
